import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserSettingsService } from '../../user-settings/services/user-settings.service';


/**
 * October demo only
 * Prevents access to a route unless user is in Dashboard mode
 * @todo This type was intended to be for October Demo only. It has been modified for Identity Server
 * adoption but it's purpose and implementation should be reviewed. 
 * */
@Injectable()
export class DashboardModeOnlyGuard  {

  constructor(
    private readonly userSettings: UserSettingsService,
    private readonly router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return this.userSettings.getUserSettings()
      .pipe(
        take(1),
        map(settings => {
          if (settings.IsInMyDashboardMode) {
            return true;
          }
          this.router.navigate(['/404']);
          return false;
        })
      );
  }

}
